/**
 * Generic utility for serializing objects to URL route parameters
 * Converts objects to JSON strings and other values to strings
 *
 * @param data - Any object to serialize for URL parameters
 * @returns Record of string key-value pairs ready for URL parameters for TanStack Router
 */
export function serializeRouteParams<T extends Record<string, any>>(
  data: T
): Record<string, string> {
  const routeParams: Record<string, string> = {};

  Object.entries(data).forEach(([key, value]) => {
    if (typeof value === "object" && value !== null) {
      routeParams[key] = JSON.stringify(value);
    } else {
      routeParams[key] = String(value);
    }
  });

  return routeParams;
}
